import { useEffect, useState } from "react";
import useFetching from "../../utils/Fetching";
import { Backdrop, CircularProgress, Grid2 } from "@mui/material";
import EditableStep from "./EditableStep";

const StepEditor = () => {
  const { getAllSteps, updateStepData, swapSteps } = useFetching();
  const [steps, setSteps] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getSteps() {
      if (steps.length === 0) {
        const response = await getAllSteps();
        const data = response.sort((a, b) => a.stepNumber - b.stepNumber);
        setSteps(data);
      }
    }
    getSteps();
  }, []);

  const hasPrevious = (stepNumber) => {
    const previous = steps.filter((step) => step.stepNumber === stepNumber - 1);
    return previous.length > 0 && previous[0].movable;
  };

  const hasNext = (stepNumber) => {
    const previous = steps.filter((step) => step.stepNumber === stepNumber + 1);
    return previous.length > 0 && previous[0].movable;
  };

  const handleChange = (stepData) => {
    const index = steps.findIndex(
      (step) => step.stepNumber === stepData.stepNumber
    );
    if (index > -1) {
      const updatedSteps = [...steps];
      updatedSteps[index] = stepData;
      updateStepData(stepData, stepData.stepNumber);
      setSteps(updatedSteps);
    }
  };

  // Move step from spot a to spot b
  const handleSwap = async (fromNum, toNum) => {
    const fromIndex = steps.findIndex((step) => step.stepNumber === fromNum);
    const toIndex = steps.findIndex((step) => step.stepNumber === toNum);

    if (fromIndex > -1 && toIndex > -1) {
      const updatedSteps = [...steps];
      updatedSteps[fromIndex].stepNumber = toNum;
      updatedSteps[toIndex].stepNumber = fromNum;

      updatedSteps.sort((a, b) => a.stepNumber - b.stepNumber);
      setIsLoading(true);
      setSteps([...updatedSteps]);
      await swapSteps(fromNum, toNum);
      setIsLoading(false);
    }
  };

  return (
    <div className="step-editor">
      <Grid2 container spacing={2}>
        {steps.length > 0 &&
          steps.map((step, index) => {
            if (step.editable || step.movable) {
              return (
                <Grid2
                  key={`step-${index}-${step.stepName}-box`}
                  size={{ xs: 12, md: 4 }}
                >
                  <EditableStep
                    key={`step-editor-step-${index}-${step.stepName}`}
                    step={step}
                    hasPrevious={hasPrevious}
                    hasNext={hasNext}
                    handleMove={handleSwap}
                    handleChange={handleChange}
                  />
                </Grid2>
              );
            }
            return <></>;
          })}
      </Grid2>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default StepEditor;
